export const environment = {
    production: false,
    environmentName: 'TEST',
    enableServiceWorker: true,
    firebase: {
        apiKey: "AIzaSyApe4Nnp2MkWlyZTH5Rxmk8Prllx7WtJaI",
        authDomain: "vmsintegration.firebaseapp.com",
        projectId: "vmsintegration",
        storageBucket: "vmsintegration.firebasestorage.app",
        messagingSenderId: "888111513646",
        appId: "1:888111513646:web:af023c48e8a7f529f61fbf",
        measurementId: "G-TY3BXVWHVL"
    },
    fcmWebPushKeyPair: "BENd_TctaRq2bg_K9mO3-pxLuZxnOm2kWXZAZiS2IAcqTybe4PGjhoofs0zs0NI5T-7-fydWsPEH5zuY9x-R72s",
    restApiUrl: "https://tatc-digital-hub-api-test-888111513646.us-central1.run.app/api/"
};
